/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import Configuration from './model/Configuration';
import PulseANSService from './PulseANSService';
import PulseUNSService from './PulseUNSService';

export default class PulseServiceFactory {
  public static getPulseService(configuration: Configuration): PulseANSService | PulseUNSService {
    if (!configuration) {
      throw new Error(`Init Pulse Service failed: Missing configuration`);
    }
    switch (configuration.env) {
      case 'dev':
      case 'qa':
      case 'stage':
        if (
          configuration.queryParams !== undefined &&
          configuration.queryParams.pulseEnv !== undefined &&
          configuration.queryParams.pulseEnv.includes('ANS')
        ) {
          return new PulseANSService(configuration);
        }
        return new PulseUNSService(configuration);
      case 'prod':
        return new PulseANSService(configuration);
    }
  }
}
